import { Link } from 'react-router';
import styled from 'styled-components';
import { LogoHolder } from '../atoms';
import { LoginForm } from '../organism';
import textsData from '@/textData/LoginScreenTexts.json'
import { useUserLanguage } from '@/customHooks/useUserLanguage';
import { pathURL } from '@/components/constants/urls';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  max-width: 600px;
  padding-top: ${({ theme }) => theme.spacing.lg};
  padding-bottom: ${({ theme }) => theme.spacing.lg};
  & > div {
    margin-bottom: ${({ theme }) => theme.spacing.md};
  }
`
const StyledText = styled.div`
  text-align: center;
  width: 300px;
  & > h1 {
    color: black;
  }
  & > p {
    word-wrap: normal;
  }
`
export const LoginTemplate = () => {
  const userLanguage = useUserLanguage();
  const texts = userLanguage === 'es' ? textsData.es.login : textsData.en.login

  return (
    <Wrapper>
      <div>
        <LogoHolder width="128" />
      </div>
      <StyledText>
        <h1>{texts.title}</h1>
        <p>
          {texts.welcome}
        </p>
      </StyledText>
        <LoginForm />
      <div>
        <Link to={`/${pathURL.LOGIN}/${pathURL.FORGOT_PASSWORD}`}>{texts.forgot}</Link>
      </div>
      <div>
        <p>{texts.signup.text}&nbsp;<Link to={`/${pathURL.LOGIN}/${pathURL.SIGN_UP}`}>{texts.signup.linkText}</Link></p>
      </div>
    </Wrapper>  
  )
}